/**
 * Régua automática, em três passos que sobrevivem às trocas de régua:
 *
 *   • "Antes" do vencimento — era o D-1; desde a reunião de 23/10/2026 é o D-3
 *     e o D0. Fatura antiga só tem o D-1, a nova tem os outros: qualquer um conta.
 *   • D+3 — fixo.
 *   • D+7 — era o D+10 até 11/08/2026 (o D+10 virou contato humano). Desde
 *     23/10/2026 ele não sai se alguém já falou com o cliente: o log guarda
 *     'suprimido' e aqui ele chega como `D+7:contato`, que também conta.
 *
 * Sem isso "3 avisos enviados" deixaria de ser verdade a cada mudança e as telas
 * que dependem disso zerariam em silêncio.
 *
 * Mora fora do hook porque a exportação em Excel escreve as mesmas colunas de
 * aviso e não pode arrastar o cliente do Supabase junto.
 */
export const TIPOS_ANTES_DO_VENCIMENTO = ['D-3', 'D0', 'D-1'];
export const TIPOS_TERCEIRO_AVISO = ['D+7', 'D+10'];
/** Sufixo do aviso que não saiu porque já havia contato humano. */
export const SUFIXO_CONTATO_HUMANO = ':contato';

/** Os três passos da régua automática, para exibição. */
export const TIPOS_AVISO = ['Antes', 'D+3', 'D+7'];

/** O passo da régua foi cumprido? Ver os rótulos aceitos no topo do arquivo. */
export function avisoEnviado(enviados: Set<string>, tipo: string): boolean {
  if (tipo === 'Antes') return TIPOS_ANTES_DO_VENCIMENTO.some(t => enviados.has(t));
  if (tipo === 'D+7') {
    return TIPOS_TERCEIRO_AVISO.some(t => enviados.has(t)) || enviados.has(`D+7${SUFIXO_CONTATO_HUMANO}`);
  }
  return enviados.has(tipo);
}

/** O D+7 ficou para o contato humano (não é falha da régua). */
export function avisoFicouComHumano(enviados: Set<string>, tipo: string): boolean {
  return enviados.has(`${tipo}${SUFIXO_CONTATO_HUMANO}`);
}

/** Recebeu os três passos da régua automática, seja qual for a régua da época. */
export function recebeuTodosOsAvisos(enviados: Set<string>): boolean {
  return TIPOS_AVISO.every(t => avisoEnviado(enviados, t));
}
